import { BaseApi } from './base'

class NewsletterApi extends BaseApi {
  constructor() {
    const baseURL = process.env.GATSBY_NEWSLETTER_HOST
    super(baseURL)
  }

  sendEmail(email, name, locale, profile) {
    return this.instance.post('/rest/v1/newsletter', { email, name, locale, profile })
  }
}

export { NewsletterApi }
